<template>
<div>
  <v-flex class="dd-dark" elevation-2 xs12  d-flex v-if="!topbarDense">
    

  </v-flex>
</div>
</template>

<script>
/* TODO: import menu from '@/api/menu'; */
import { mapGetters } from 'vuex'
import * as types from "../../store/types"

export default {
  data () {
    return {
      title: ''
    };
  },
  computed: {
    ...mapGetters({
      breadcrumbs: types.CURRENT_BREADCRUMBS,
      hideBreadcrumbs: types.HIDE_BREADCRUMBS,
      topbarDense: types.TOPBAR_DENSE
    }),
    // breadcrumbs: function () {
    //   let crumbs = [];
    //
    //   this.title = "Home"
    //   crumbs.push('Master')
    //   crumbs.push('child')
    //   crumbs.push('grandchild')
    //   /* TODO: make crumb logic work
    //   menu.forEach(item => {
    //     if (item.items) {
    //       let child =  item.items.find(i => {
    //         return i.component === this.$route.name;
    //       });
    //       if (child) {
    //         breadcrumbs.push(item.title);
    //         breadcrumbs.push(child.title);
    //         this.title = child.title;
    //       }
    //     } else {
    //       if (item.name === this.$route.name) {
    //         this.title = item.title;
    //         breadcrumbs.push(item.title);
    //       }
    //     }
    //   });
    //   */
    //
    //   return crumbs;
    // },
  }
};
</script>

<style scoped>

</style>
